import { Breadcrumb } from 'modules/model-json';

export const ADPLATFORM_TRAINING_PATH = '/promo/obuchenie-po-reklamnoy-platforme/';

export const ADPLATFORM_TRAINING_ELEMENT_BLOCK = 'landingObuchenieAdPlatform';

export const ADPLATFORM_TRAINING_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/adplatform-training';

export const ADPLATFORM_TRAINING_LANDING_NAME = 'adplatform-training';

export const ADPLATFORM_TRAINING_BREADCRYMBS: Breadcrumb[] = [
  {
    label: 'Рекламная платформа',
    link: '/promotion/',
  },
  {
    label: 'Обучение',
    link: '/promo/obuchenie-po-reklamnoy-platforme/',
  },
];
